export const stepOneData = [
  {
    heading:
      "Why Use Minemi’s EMI Calculator for Kotak Mahindra Bank Car Loans?",
    subOneList: [
      {
        head: "Accurate EMI Estimates: ",
        text: "Get precise monthly payment calculations based on your loan amount, interest rate, and tenure.",
      },
      {
        head: "Compare Multiple Lenders: ",
        text: "Evaluate loan offers side-by-side to find the best deal for your dream car.",
      },
      {
        head: "Prepayment Insights: ",
        text: "See how partial prepayments can reduce your EMI or loan tenure.",
      },
      {
        head: "Loan Affordability: ",
        text: "Plan how much you can comfortably borrow based on your income and financial obligations.",
      },
      {
        head: "Separate Rates for New & Used Cars: ",
        text: "Understand that interest rates for new cars are generally lower than those for used cars due to reduced risks for lenders.",
      },
      {
        head: "Simple & Time-Saving: ",
        text: "Minemi makes it easy to calculate and plan your car loan in minutes.",
      },
    ],

    tip: "<strong>Choose the Right Tenure for Your Loan</strong> </br> Shorter tenures mean higher EMIs but lower overall interest payments. Longer tenures reduce EMIs but increase the total cost of the loan. Use Minemi’s Car Loan EMI Calculator to find the perfect balance between monthly affordability and long-term savings.",
  },
];

export const stepTwoData = [
  {
    heading: "What You Can Do With the Car Loan EMI Calculator?",

    subOneList: [
      {
        head: "Estimate Monthly Payments: ",
        text: "Enter your loan amount, interest rate, and tenure to get an instant estimate of your car loan EMI.",
      },
      {
        head: "Compare Loan Offers: ",
        text: "Adjust parameters like tenure, loan amount, and interest rate to simulate various loan scenarios and find the most affordable option.",
      },
      {
        head: "Plan Prepayments: ",
        text: "Use the calculator to understand how prepaying a portion of your loan can reduce your EMI or loan tenure.",
      },
      {
        head: "Personal Loan Refinance Calculator: ",
        text: "Consider whether to refinance an existing loan.",
      },
    ],

    tip: "<strong>Negotiate for Better Interest Rates</strong> </br> Improve your credit score to qualify for lower interest rates. Compare offers from multiple lenders and negotiate better terms. Look for festive discounts or special promotions to reduce your interest rate",

    paraOne: "Sample EMI Calculation for Kotak Mahindra Bank Car Loans",

    tableContent: {
      heading: [
        {
          head: "Car Type",
        },
        {
          head: "Loan Amount",
        },
        {
          head: "Interest Rate (%)",
        },
        {
          head: "Tenure (Years)",
        },
        {
          head: "EMI (₹)",
        },
        {
          head: "Total Interest (₹)",
        },
        {
          head: "Total Payment  (₹)",
        },
      ],
      row: [
        {
          type: "New Car",
          amount: "₹6,00,000",
          interest: "8.75%	",
          tenure: "5",
          emi: "₹12,387",
          tInterest: "₹1,43,220",
          payment: "₹7,43,220",
        },
        {
          type: "Used Car",
          amount: "₹6,00,000",
          interest: "11.25%	",
          tenure: "5",
          emi: "₹13,098",
          tInterest: "₹1,85,880",
          payment: "₹7,85,880",
        },
        {
          type: "New Car",
          amount: "₹8,00,000",
          interest: "8.50%",
          tenure: "3",
          emi: "₹25,238",
          tInterest: "₹1,08,568",
          payment: "₹9,08,568",
        },
        {
          type: "Used Car",
          amount: "₹6,00,000",
          interest: "10.75%",
          tenure: "3",
          emi: "₹19,567",
          tInterest: "₹1,04,412",
          payment: "₹7,04,412",
        },
      ],
    },

    note: "<strong>Note</strong>: Interest rates for used cars are typically higher than those for new cars due to greater risks and depreciation. Use Minemi’s calculators for customized results.",

    cta: "Confused about car loan eligibility? Visit our Car Loan Eligibility Guide for detailed insights.",
  },
];

export const stepThreeData = [
  {
    heading: "How to Maximize Savings on Your Car Loan",

    subOneList: [
      {
        head: "Make a Bigger Down Payment: ",
        text: "A higher down payment reduces the loan amount, leading to lower EMIs and interest costs.",
      },
      {
        head: "Compare Interest Rates: ",
        text: "Even a small reduction in the interest rate can save you thousands over the loan tenure. Use Minemi to compare rates for both new and used cars.",
      },
      {
        head: "Avoid Over-Borrowing: ",
        text: "Borrow only what you need and can comfortably repay. Use the EMI calculator to find the optimal loan amount.",
      },
      {
        head: "Opt for Prepayment: ",
        text: "Pay off a portion of your loan early to reduce your EMI or loan tenure.",
      },
    ],
    tip: "<strong>Watch Out for Hidden Charges</strong> </br> Processing fees, foreclosure charges, and documentation fees can increase your loan cost. Always ask for a breakdown of charges before finalizing your loan. Use Minemi’s resources to understand and account for these costs. ",
  },
];

export const stepFourData = [
  {
    heading: "Understanding Kotak Mahindra Bank Car Loan Features",

    subOneList: [
      {
        head: "Competitive Interest Rates: ",
        text: "Starting from 8.50% for new cars and 10.75% for used cars.",
      },
      {
        head: "Flexible Tenure: ",
        text: "Repayment options ranging from 1 to 7 years.",
      },
      {
        head: "Quick Approval: ",
        text: "Fast processing and minimal documentation.",
      },
      {
        head: "Top-Up Loans: ",
        text: "Avail additional funds for car accessories or repairs.",
      },
    ],

    tip: "<strong>Maximize Tax Benefits</strong>: Utilize the tax benefits available on car loans to reduce your overall tax liability. Consult a tax advisor to understand how you can save more.",
  },
];

export const stepFiveData = [
  {
    heading: "Tax Benefits on Car Loans",

    subOneList: [
      {
        head: "Section 80C: ",
        text: "Claim deductions on the principal repayment if the car is used for business purposes.",
      },
      {
        head: "Section 24: ",
        text: "Claim deductions on the interest paid if the car is used as a business asset.",
      },
    ],
  },
];
export const stepSixData = [
  {
    heading: "How to Maximize Savings on Your Kotak Mahindra Bank Car Loan",

    subOneList: [
      {
        head: "Make a Bigger Down Payment: ",
        text: "A higher down payment reduces the loan amount, leading to lower EMIs and interest costs.",
      },
      {
        head: "Compare Interest Rates: ",
        text: "Even a small reduction in the interest rate can save you thousands over the loan tenure. Use Minemi to compare rates for both new and used cars.",
      },
      {
        head: "Avoid Over-Borrowing: ",
        text: "Borrow only what you need and can comfortably repay. Use the EMI calculator to find the optimal loan amount.",
      },
      {
        head: "Opt for Prepayment: ",
        text: "Pay off a portion of your loan early to reduce your EMI or loan tenure.",
      },
    ],
    cta: "Looking for the best car loan interest rates? Check out our Car Loan Interest Rates Comparison page.",
  },
];
